<template>
  <div>
    <VipPayComponent ref="VipPayComponent" @checkPay="checkPay"></VipPayComponent>
    <TitleCard
        :title="isNaN($route.params.id) ? `新增线路` : `编辑线路`"
        style="margin: 10px 10px; max-width: 99%; border-radius: 15px"
    >
      <template v-slot:subTitle>
        <ul
            class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1"
            style="display: flex"
        >
          <li
              class="breadcrumb-item text-muted"
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"
              style="font-family: 'Roboto', sans-serif"
          >
            Add Tourist Itinerary
          </li>

          <div
              class="align-items-center py-3"
              style="position: absolute; right: 0; padding: 0px 30px"
          >
            <a
                href="javascript:void(0)"
                class="btn btn-sm btn-primary mx-2"
                @click="$router.replace('/travel')"
            >返回到旅游线路管理</a
            >
          </div>
        </ul>
      </template>
    </TitleCard>
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="app-content" style="padding-top: 10px">
          <form
              onsubmit="return false;"
              id="kt_ecommerce_add_product_form"
              class="form d-flex flex-column flex-lg-row"
              data-kt-redirect="../../demo43/dist/apps/ecommerce/catalog/products.html"
          >
            <div
                class="d-flex flex-column gap-7 gap-lg-10 w-100 w-lg-300px mb-7 me-lg-10"
                style="padding-left: 13px; margin-right: 14px !important"
            >
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h2 class="required">主图</h2>
                  </div>
                </div>
                <div class="card-body text-center pt-0">
                  <div
                      class="image-input image-input-outline image-input-placeholder mb-3"
                      :class="
                      goodsInfo.picUrl != ''
                        ? `image-input-empty`
                        : `image-input-changed`
                    "
                      data-kt-image-input="true"
                  >
                    <!-- image-input image-input-empty image-input-outline image-input-placeholder mb-3 -->
                    <div
                        class="image-input-wrapper w-150px h-150px"
                        :style="`background-image: url(${goodsInfo.picUrl})`"
                    ></div>
                    <label
                        class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="change"
                        data-bs-toggle="tooltip"
                        title="上传主图"
                    >
                      <i class="ki-outline ki-pencil fs-7"></i>
                      <input
                          type="file"
                          name="avatar"
                          accept=".png, .jpg, .jpeg"
                          @change="uploadFileAvatar"
                      />
                      <input type="hidden" name="avatar_remove"/>
                    </label>
                    <span
                        class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="cancel"
                        data-bs-toggle="tooltip"
                        @click="romverAvatar"
                        title="删除主图"
                    >
                      <i class="ki-outline ki-cross fs-2"></i>
                    </span>
                    <span
                        class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="remove"
                        data-bs-toggle="tooltip"
                        title="Remove avatar"
                    >
                      <i class="ki-outline ki-cross fs-2"></i>
                    </span>
                  </div>
                  <div class="text-muted fs-7">
                    设置产品缩略图。仅上传 *.png、*.jpg 和 *.jpeg 图片文件。
                  </div>
                </div>
              </div>
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h4 class="required">是否上架</h4>
                  </div>
                </div>
                <div class="card-body pt-0">
                  <el-switch
                      v-model="goodsInfo.isShow"
                      active-color="#13ce66"
                      inactive-color="#999"
                      active-value="1"
                      inactive-value="2"
                  >
                  </el-switch>
                </div>
              </div>

              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h4>线路分类</h4>
                  </div>
                </div>
                <div class="card-body pt-0">
                  <select
                      class="form-select form-select-solid"
                      v-model="goodsInfo.type"
                      ref="category1Name"
                      data-placeholder="全部"
                  >
                    <option value="">请选择</option>
                    <option value="1">疗愈放松（温泉养生、森林疗愈、静修冥想）</option>
                    <option value="2">亲子家庭（乐园体验、亲子研学、亲子度假）</option>
                    <option value="3">人文探索（文化溯源、世界遗产、历史古迹）</option>
                    <option value="4">季节限定（樱花祭、狂欢节、圣诞跨年）</option>
                    <option value="5">邮轮度假（海上巡游、内河邮轮、奢华邮轮）</option>
                    <option value="6">热门线路（用来涵盖所有上述未涵盖内容）</option>
                  </select>
                </div>
              </div>

              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h2>价格管理</h2>
                  </div>
                </div>
                <div class="card-body pt-0">
                  <label class="fs-6 form-label fw-bolder text-dark required"
                  >划线价</label
                  >
                  <input
                      type="text"
                      name="weight"
                      id="weight"
                      class="form-control form-control-lg form-control-solid"
                      placeholder="划线价"
                      value=""
                      v-model="goodsInfo.linePrice"
                  />
                  <label class="fs-6 form-label fw-bolder text-dark required"
                  >市场价</label
                  >
                  <input
                      type="text"
                      name="weight"
                      id="weight"
                      class="form-control form-control-lg form-control-solid"
                      placeholder="市场价"
                      value=""
                      v-model="goodsInfo.price"
                  />

                  <label
                         class="fs-6 form-label fw-bolder text-dark required"
                  >定金</label
                  >
                  <input type="text"
                      name="weight"
                      id="weight"
                      class="form-control form-control-lg form-control-solid"
                      placeholder="定金"
                      value=""
                      v-model="goodsInfo.deposit"
                  />



                </div>
              </div>
            </div>
            <div
                class="flex-column flex-row-fluid gap-7 gap-lg-10"
                style="margin-right: 10px"
            >
              <ul
                  class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-n2"
                  style="
                  background-color: #fff !important;
                  padding: 17px;
                  border-radius: 15px 15px 0 0;
                  margin-bottom: 0 !important;
                  padding-bottom: 2px !important;
                "
              >
                <li class="nav-item">
                  <a
                      class="nav-link text-active-primary pb-4 active"
                      data-bs-toggle="tab"
                      href="#kt_ecommerce_add_product_general"
                  >线路详情</a
                  >
                </li>
<!--                <li class="nav-item">
                  <a
                      class="nav-link text-active-primary pb-4"
                      data-bs-toggle="tab"
                      href="#kt_ecommerce_add_product_advanced"
                  >规格</a
                  >
                </li>-->
              </ul>
              <div class="tab-content">
                <div
                    class="tab-pane fade show active"
                    id="kt_ecommerce_add_product_general"
                    role="tab-panel"
                >
                  <div class="d-flex flex-column gap-7 gap-lg-10">
                    <div
                        class="card card-flush py-4"
                        style="
                        border-radius: 0 0 15px 15px !important;
                        height: 351px;
                      "
                    >
                      <div class="card-header">
                        <div class="card-title">
                          <h2 class="required">线路标题</h2>
                        </div>
                      </div>
                      <div class="card-body pt-0">
                        <div class="mb-10 fv-row">
                          <!-- <label class="required form-label">商品标题</label> -->
                          <input
                              type="text"
                              name="product_name"
                              class="form-control mb-2"
                              placeholder="线路标题"
                              value=""
                              v-model="goodsInfo.title"
                          />
                        </div>
                        <div class="card-body border-top p-9">
                          <div class="row mb-6">
                            <label class="col-lg-2 col-form-label fw-bold fs-6 required">
                              <span>线路副标题</span>
                            </label>
                            <div class="col-lg-10 fv-row">
                              <input
                                  type="text"
                                  name="weight"
                                  id="weight"
                                  class="form-control form-control-lg form-control-solid"
                                  placeholder="请输入线路副标题"
                                  value=""
                                  v-model="goodsInfo.subTitle"
                              />
                            </div>
                          </div>
                          <div class="row mb-6">
                            <label
                                class="col-lg-2 col-form-label fw-bold fs-6"
                            >排序</label
                            >
                            <div class="col-lg-4 fv-row">
                              <input
                                  type="text"
                                  name="weight"
                                  id="weight"
                                  class="form-control form-control-lg form-control-solid"
                                  placeholder="请输入排序"
                                  value=""
                                  v-model="goodsInfo.sortNum"
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="card card-flush py-4">
                      <div class="card-header">
                        <div class="card-title">
                          <h2 class="required">轮播图管理</h2>
                        </div>
                      </div>
                      <div style="margin: 20px">
                        <UploadFile
                            moduleName="moduleName"
                            accept=".png,.jpg,.jpeg"
                            @upload-success="uploadSuccess"
                        ></UploadFile>
                        <div class="imgList">
                          <div
                              v-for="(item, index) in imgList"
                              :key="index"
                              class="imgItem"
                          >
                            <img width="300px" alt="" :src="item"/>
                            <button
                                @click="removeImages(item, index)"
                                class="removeImage"
                            >
                              <i class="el-icon-close"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card card-flush py-4">
                      <div class="card-header">
                        <div class="card-title">
                          <h2 class="required">亮点</h2>
                        </div>
                      </div>
                      <div style="margin: 20px">
                        <Tinymce
                            v-if="status == 0"
                            ref="editor"
                            v-model="goodsInfo.highlights"
                            :height="300"
                        ></Tinymce>
                      </div>
                    </div>

                    <div class="card card-flush py-4">
                      <div class="card-header">
                        <div class="card-title">
                          <h2 class="required">行程</h2>
                        </div>
                      </div>
                      <div style="margin: 20px">
                        <Tinymce
                            v-if="status == 0"
                            ref="editor"
                            v-model="goodsInfo.trip"
                            :height="300"
                        ></Tinymce>
                      </div>
                    </div>

                    <div class="card card-flush py-4">
                      <div class="card-header">
                        <div class="card-title">
                          <h2 class="required">服务</h2>
                        </div>
                      </div>
                      <div style="margin: 20px">
                        <Tinymce
                            v-if="status == 0"
                            ref="editor"
                            v-model="goodsInfo.service"
                            :height="300"
                        ></Tinymce>
                      </div>
                    </div>

                    <div class="card card-flush py-4">
                      <div class="card-header">
                        <div class="card-title">
                          <h2 class="required">规则</h2>
                        </div>
                      </div>
                      <div style="margin: 20px">
                        <Tinymce
                            v-if="status == 0"
                            ref="editor"
                            v-model="goodsInfo.rule"
                            :height="300"
                        ></Tinymce>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-2">
                <a
                    href="javascript:void(0)"
                    id="kt_ecommerce_add_product_cancel"
                    class="btn btn-light me-5"
                    @click="$router.push('/travel')"
                >取消</a
                >
<!--                <button
                    v-if="!(role.includes('firstGradeSupplier') && goodsInfo.type == 2)"
                    type="submit"
                    id="kt_ecommerce_add_product_submit"
                    class="btn text-light text-bg-info text-hover-muted me-5"
                    @click="saveGoodsInfo(1)"
                >
                  <span class="indicator-label">提交并保留当前数据</span>
                  <span class="indicator-progress"
                  >Please wait...
                    <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span
                    ></span>
                </button>-->
                <button
                    type="submit"
                    id="kt_ecommerce_add_product_submit"
                    class="btn text-light text-bg-info text-hover-muted"
                    @click="saveGoodsInfo(0)"
                >
                  <span class="indicator-label">提交</span>
                  <span class="indicator-progress"
                  >Please wait...
                    <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span
                    ></span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {addOrUpdateTravel} from "./addOrUpdateTravel.js"

export default {
  // key不能动
  mixins: [addOrUpdateTravel]
};
</script>

<!--<script>
import { removeFileApi, uploadFileApi } from "@/api/uploadFileApi";
import { getCategoryList, getValueListApi } from "@/api/categoryApi";
import { getFreightSelectApi } from "@/api/freightApi";
import { getDeliveryListApi } from "@/api/deliveryApi";
import { getInstallSelectApi } from "@/api/install";
import { deliveryTime } from "@/utils/goodsUtil";
import {
  getGoodsAssistantApi,
  getGoodsInfoApi,
  saveSjGoodsApi,
} from "@/api/goodsManageApi";
import Tinymce from "@/components/Tinymce/indexBak.vue";

export default {
  props: {},
  data() {
    return {
      isStartNum:1,
      deliveryTime,
      imgList: [],
      categoryOne: [],
      categoryTwo: [],
      categoryThree: [],
      deliveryList: [],
      freight: [],
      installList: [],
      isJdUrl: "1",
      goodsUrl: "",
      // 商品信息
      goodsInfo: {
        id: "",
        spuId: "",
        title: "",
        spuTitle: "",
        categoryId1: "",
        categoryId2: "",
        categoryId3: "",
        categoryId1Name: "",
        categoryId2Name: "",
        categoryId3Name: "",
        detail: "",
        specialSpec: "",
        price: "",
        supplPrice: "",
        salePrice: "",
        jdUrl: "",
        comparePrice: "1",
        buyType: "1",
        startNum: "1",
        isInstall: "",
        isDelivery: "",
        deliveryId: "",
        freightId: "",
        stock: "",
        weight: "",
        picUrl: "",
        sevenNRR: "1",
        isShow: "",
        isQuan: "",
        saleAttrs: [],
        sjGoodsFile: [],
        deliveryTime: "24小时内发货",
      },
      valueSize: 0,
      valueList: [],
      arr: [],
      specialSpec: null,
      specialSpecObj: {},
      specialSpecArr: [],
      status: 0,
      goodsStatus: "",
      role: [],
    };
  },
  methods: {
    //移除图片
    async removeImages(item, index) {
      this.imgList.splice(index, 1);
      if ( this.goodsInfo.spuId != "" && this.goodsInfo.id == ""){
        return;
      } else{
        await removeFileApi({
          url: item,
        });
      }
      // if ((this.goodsInfo.spuId =="" && this.goodsInfo.id =="") || (this.goodsInfo.spuId !="" && this.goodsInfo.id !="") ) {

      // }
    },
    // 移除销售规格
    removeValue(index) {
      this.arr.splice(index, 1);
    },
    //保存
    async saveGoodsInfo(e) {
      if (e === 1){
        this.goodsInfo.id = null;
      }

      this.goodsInfo.sjGoodsFile = [];
      let obj = {};
      if (this.specialSpecArr){
        this.specialSpecArr.forEach((e, index) => {
          if (e.name){
            obj[e.key] = e.name;
          }
        });
        this.goodsInfo.specialSpec = JSON.stringify(obj);
      } else {
        this.goodsInfo.specialSpec = null;
      }

      this.goodsInfo.saleAttrs = this.arr;

      let categoryId1Name = this.$refs.category1Name;
      let categoryId1Index = categoryId1Name.selectedIndex;

      if (this.goodsInfo.categoryId1) {
        this.goodsInfo.categoryId1Name =
          categoryId1Name.options[categoryId1Index].text;
      } else {
        this.goodsInfo.categoryId1Name = "";
        this.goodsInfo.categoryId1 = "";
      }

      let categoryId2Name = this.$refs.category2Name;
      let categoryId2Index = categoryId2Name.selectedIndex;
      if (this.goodsInfo.categoryId2) {
        this.goodsInfo.categoryId2Name =
          categoryId2Name.options[categoryId2Index].text;
      } else {
        this.goodsInfo.categoryId2Name = "";
        this.goodsInfo.categoryId2 = "";
      }

      let categoryId3Name = this.$refs.category3Name;
      let categoryId3Index = categoryId3Name.selectedIndex;
      if (this.categoryThree.length!=0) {
        this.goodsInfo.categoryId3Name =
          categoryId3Name.options[categoryId3Index].text;
      } else {
        this.goodsInfo.categoryId3Name = "";
        this.goodsInfo.categoryId3 = "";
      }
      if (this.goodsInfo.buyType == 1) {
        this.goodsInfo.startNum = 1;
      }

      this.imgList.forEach((item, index) => {
        this.goodsInfo.sjGoodsFile.push({ name: index, url: item });
      });
      if (this.goodsStatus == 1) {
        this.goodsInfo.id = "";
      }
      if (!this.ruleForm()) {
        return;
      }
      if (this.isStartNum==1) {
        this.goodsInfo.startNum=1
      }
      let { data } = await saveSjGoodsApi(this.goodsInfo);
      this.goodsInfo.spuId = data.spuId;
      this.$swal.fire({
        icon: "success",
        title: "保存成功",
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 2000,
      });
      if (e == 0) {
        this.$router.push("/goods");
      }
    },
    // 表单规则
    ruleForm() {
      console.log(this.goodsInfo.picUrl)
      //检查主图
      if (!this.goodsInfo.picUrl) {
        this.$swal.fire({
          icon: "warning",
          title: "请上传商品主图",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查市场价
      if (!this.goodsInfo.price) {
        this.$swal.fire({
          icon: "warning",
          title: "请填写商品市场价",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查分销价
      if (!this.goodsInfo.supplPrice) {
        this.$swal.fire({
          icon: "warning",
          title: "请填写商品分销价",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查销售价
      if (!this.goodsInfo.salePrice) {
        this.$swal.fire({
          icon: "warning",
          title: "请填写商品销售价",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查一级分类
      if (!this.goodsInfo.categoryId1) {
        this.$swal.fire({
          icon: "warning",
          title: "请选择一级分类",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查二级分类
      if (!this.goodsInfo.categoryId2) {
        this.$swal.fire({
          icon: "warning",
          title: "请选择二级分类",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查当存在三级分类是判断是否选择三级分类
      if (this.categoryThree.length!=0 && this.goodsInfo.categoryId3=="") {
        this.$swal.fire({
          icon: "warning",
          title: "请选择三级分类",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查商品标题
      if (!this.goodsInfo.title) {
        this.$swal.fire({
          icon: "warning",
          title: "请填写商品标题",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查库存
      if (!this.goodsInfo.stock) {
        this.$swal.fire({
          icon: "warning",
          title: "请填写商品库存",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查运费模板
      if (!this.goodsInfo.freightId) {
        this.$swal.fire({
          icon: "warning",
          title: "请选择运费模板",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查送货上门
      if (!this.goodsInfo.isDelivery) {
        this.$swal.fire({
          icon: "warning",
          title: "请选择是否送货上门",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查送货上门模板
      if (this.goodsInfo.isDelivery=="1"&&this.goodsInfo.deliveryId=="") {
        this.$swal.fire({
          icon: "warning",
          title: "请选择送货上门模板",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }

      // goodsInfo.deliveryId
      //检查是否有上门安装
      if (!this.goodsInfo.isInstall) {
        this.$swal.fire({
          icon: "warning",
          title: "请选择是否有上门安装",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查有上门安装模板
      if (this.goodsInfo.isInstall=="1"&&this.goodsInfo.installId=="") {
        this.$swal.fire({
          icon: "warning",
          title: "请选择送货上门模板",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查是否支持比价
      if (this.isJdUrl==1 && this.goodsInfo.jdUrl=="") {
        this.$swal.fire({
          icon: "warning",
          title: "请填写比价链接",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查商品详情
      if (!this.goodsInfo.detail) {
        this.$swal.fire({
          icon: "warning",
          title: "请填写商品详情",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查轮播图
      if (!this.imgList.length) {
        this.$swal.fire({
          icon: "warning",
          title: "请上传轮播图",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      //检查销售方式
      if (this.isStartNum==2 && this.goodsInfo.startNum=="") {
        this.$swal.fire({
          icon: "warning",
          title: "请填写集采数量",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }

      return true;
    },
    // saveGoodsInfo() {},
    uploadSuccess(res, fileList) {
      this.imgList.push(res.data.fileUrl);
    },
    //上传文件
    async uploadFileAvatar(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("moduleName", "goodsAvatar");
      let { data } = await uploadFileApi(formData);
      this.goodsInfo.picUrl = data.fileUrl;
    },
    //初始化分类
    async initCategory(level,item) {
      let { data } = await getCategoryList({
        parentId: item || 0,
      });
      if (level == '' || level == null) {
        this.categoryOne = data.list;
      }
      if (level === 2) {
        this.categoryTwo = data.list;
      }
      if (level === 3) {
        this.categoryThree = data.list;
      }
    },
    //移除主图
    romverAvatar() {
      this.goodsInfo.picUrl = "";
    },
    async findCategory(index) {
      if (index == 1) {

        if (this.goodsInfo.categoryId1 != "" && this.goodsInfo.categoryId1 != null) {
          this.categoryTwo = [];
          this.categoryThree = [];
          this.goodsInfo.categoryId2 = "";
          this.goodsInfo.categoryId3 = "";
          let { data } = await getCategoryList({
            parentId: this.goodsInfo.categoryId1,
          });
          this.categoryTwo = data.list;
        } else {
          this.initCategory();
        }
      }

      if (index == 2) {

        if (this.goodsInfo.categoryId2 != "" && this.goodsInfo.categoryId2 != null) {
          this.categoryThree = [];
          this.goodsInfo.categoryId3 = "";
          let { data } = await getCategoryList({
            parentId: this.goodsInfo.categoryId2,
          });
          this.categoryThree = data.list;
          if (this.categoryThree.length == 0) {
            this.getValueList();
          }
        }
      }
      if (index == 3) {
        if (!this.goodsInfo.categoryId3) {
          this.goodsInfo.categoryId3 = "";
          this.goodsInfo.categoryId3Name = "";
        }
        this.getValueList();
      }
    },
    //获取运费模板
    async getFreightSelect() {
      let {
        data: { area },
      } = await getFreightSelectApi();
      this.freight = area;
    },
    async getDeliveryList() {
      let { data } = await getDeliveryListApi();
      this.deliveryList = data.area;
    },
    // 获取上门安装
    async getInstallSelect() {
      let { data } = await getInstallSelectApi();
      this.installList = data.area;
    },
    //获取商品规格
    async getValueList(index) {
      if (!this.goodsInfo.categoryId3) {
        return;
      }
      let categoryId3;
      if (this.categoryThree.length == 0) {
        categoryId3 = this.goodsInfo.categoryId2;
      } else {
        categoryId3 = this.goodsInfo.categoryId3;
      }

      let { data } = await getValueListApi({
        attrType: 1,
        categoryId3,
      });
      let arr = [];
      data.forEach((element) => {
        arr.push({
          key: element.key,
          value: eval(element.value),
          name: "",
        });
      });
      this.specialSpecArr = arr;
      this.specialSpec = data;
    },
    assistant() {
      if (this.goodsUrl == "") {
        Message({
          message: "请输入京东商品链接",
          type: "error",
          duration: 5 * 1000,
        });
        return;
      }
      let url = encodeURIComponent(this.goodsUrl);
      this.$router.push({
        name: "AddOrUpdateVisible",
        params: { id: url },
      });
    },
    addValues() {
      this.valueSize++;
      this.arr.push({ attrId: this.valueSize, attrName: "", attrValue: "" });
    },
    async getGoodsInfo(id) {
      let { data } = await getGoodsInfoApi({ id });
      this.goodsInfo = data;
      this.initCategory(2,data.categoryId1)
      await this.initCategory(3,data.categoryId2)
      this.getFreightSelect();
      this.getInstallSelect();
      this.getDeliveryList();
      await this.getValueList(2);
      if (this.goodsInfo.saleAttrVo){
        this.arr = this.goodsInfo.saleAttrVo;
      }
      if (data.jdUrl == "") {
        this.isJdUrl = "2";
      } else {
        this.isJdUrl = "1";
      }
      if (data.startNum==1) {
        this.isStartNum=1
      }else{
        this.isStartNum=2
      }
      if (this.specialSpecArr.length > 0 && this.goodsInfo.specialSpec){
        this.specialSpecArr.forEach((e, index) => {
          let json = JSON.parse(`{${data.specialSpec}}`);
          let key = e.key;
          this.specialSpecArr[index].name = json[key];
        });
      }
      if (data.sjGoodsFile.length > 0){
        data.sjGoodsFile.forEach((e, index) => {
          this.imgList.push(e.url);
        });
      }
    },
    //上架小助手
    async goodsAssistant(url) {
      url = decodeURIComponent(url);
      let id = url.match(/(\d+)/)[0];
      let { data } = await getGoodsAssistantApi({ id });
      data.spuId = '';
      this.goodsInfo = data;
      this.initCategory(2,data.categoryId1)
      await this.initCategory(3,data.categoryId2)
      this.goodsInfo.saleAttrs = [];
      this.getFreightSelect();
      this.getDeliveryList();
      this.goodsInfo.freightId = "";
      await this.getValueList(2);
      if (data.jdUrl == "") {
        this.isJdUrl = "2";
      } else {
        this.isJdUrl = "1";
        this.goodsInfo.jdUrl = url;
      }
      this.goodsInfo.isDelivery = "2";
      this.goodsInfo.isInstall = "2";
      if (this.specialSpecArr.length > 0 && this.goodsInfo.specialSpec) {
        this.specialSpecArr.forEach((e, index) => {
          let json = JSON.parse(`${data.specialSpec}`);
          let key = e.key;
          this.specialSpecArr[index].name = json[key];
        });
      }
      if (data.sjGoodsFile.length > 0){
        data.sjGoodsFile.forEach((e, index) => {
          this.imgList.push(e.url);
        });
      }
    },
    getLoginRole() {
      this.role = localStorage.getItem('role')
      console.log(this.role)
    }
  },
  created() {
    this.getLoginRole();
    this.initCategory();
    this.getFreightSelect();
    if (this.$route.params.id) {
      let id = this.$route.params.id;
      if (!isNaN(id)) {
        let status = this.$route.params.status;
        this.goodsStatus = status;
        this.getGoodsInfo(id);
      } else {
        this.goodsAssistant(id);
      }
    }
  },
  mounted() {},
  components: { uploadFileApi, Tinymce },
};
</script>-->

<style scoped>
.imgList {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-around; */
}

.imgItem {
  width: 200px;
  aspect-ratio: 800/780;
  padding: 1px;
  margin-top: 24px;
  position: relative;
  margin-right: 50px;
}

.imgItem img {
  width: 100%;
  height: 100%;
}

.removeImage {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 25px;
  height: 25px;
  background: #ffffffc9;
  border-radius: 50%;
  border: 0;
  text-align: center;
  line-height: 25px;
}
</style>
